import crudFactory from "../crudFactory.ts";

const MODEL = "dashboard-widget/dashboards";

const COMMON_CRUD_APIs = crudFactory(MODEL);

export default { ...COMMON_CRUD_APIs };
